import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationEmployeesView.css';

import { apiUrl } from '../../../utility/Connections';

import { Button, Divider, Layout } from 'antd';
import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableEmployees from '../../../components/tableEmployees/tableEmployees';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
import ModalEmployee from '../../../components/modalEmployee/modalEmployee';
import { UserAddOutlined } from '@ant-design/icons';
const { Content } = Layout;

const OrganizationEmployeesView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [dataEmployees, setDataEmployees] = useState([]);
    const [dataEmployee, setDataEmployee] = useState({});
    const [filteredDataEmployees, setFilteredDataEmployees] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [orgId, setOrgId] = useState("");

    const [fileCharged, setFileCharged] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");

    const [newEmployee, setNewEmployee] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [tableTotal, setTableTotal] = useState(0);
    const [tableParams, setTableParams] = useState({
        page: 1,
        page_size: 20,
        search: '',
        ordering: 'empl_last_name',
        filters: {},
    });

    // States de selects
    const [organizationHqs, setOrganizationHqs] = useState([])
    const [managementAreas, setManagementAreas] = useState([])
    const [areas, setAreas] = useState([])
    const [jobCategories, setJobCategories] = useState([])
    const [jobTitles, setJobTitles] = useState([])

    // States del colaborador
    const [emplId, setEmplId] = useState(null);
    const [emplUsrId, setEmplUsrId] = useState(null);
    const [emplOrgId, setEmplOrgId] = useState(null);
    const [emplFirstName, setEmplFirstName] = useState("");
    const [emplLastName, setEmplLastName] = useState("");
    const [emplDni, setEmplDni] = useState("");
    const [emplEmail, setEmplEmail] = useState("");
    const [emplBirthDate, setEmplBirthDate] = useState(null);
    const [emplGender, setEmplGender] = useState("");
    const [emplOrganizationHqId, setEmplOrganizationHqId] = useState(null);
    const [emplOrganizationHqName, setEmplOrganizationHqName] = useState("");
    const [emplManagementAreaId, setEmplManagementAreaId] = useState(null);
    const [emplManagementAreaName, setEmplManagementAreaName] = useState("");
    const [emplAreaId, setEmplAreaId] = useState(null);
    const [emplAreaName, setEmplAreaName] = useState("");
    const [emplJobCategoryId, setEmplJobCategoryId] = useState(null);
    const [emplJobCategoryName, setEmplJobCategoryName] = useState("");
    const [emplJobTitleId, setEmplJobTitleId] = useState(null);
    const [emplJobTitleName, setEmplJobTitleName] = useState("");
    const [emplEntryDate, setEmplEntryDate] = useState(null);
    const [emplActive, setEmplActive] = useState(true);

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getEmployees(current_org.org_id, { page: 1, page_size: 20, search: '', ordering: 'empl_last_name', filters: {} });
        }
    }, [])

    const getEmployees = (orgId, params) => {
        setShowLoading(true);
        setLoadingText("Cargando colaboradores...");
        const token = localStorage.getItem('access_token');
        const headers = { headers: { 'Authorization': `Bearer ${token}` } };

        const { page, page_size, search, ordering, filters } = params || tableParams;

        const filterParams = Object.entries(filters || {})
            .filter(([, vals]) => vals && vals.length > 0)
            .map(([key, vals]) => {
                const backendKey = {
                    empl_organization_hq_name: 'sede',
                    empl_management_area_name: 'gerencia',
                    empl_area_name: 'area',
                    empl_job_category_name: 'categoria',
                    empl_job_title_name: 'cargo',
                }[key];
                return backendKey ? `${backendKey}=${encodeURIComponent(vals.join(','))}` : null;
            })
            .filter(Boolean)
            .join('&');

        const query = [
            `page=${page}`,
            `page_size=${page_size}`,
            search ? `search=${encodeURIComponent(search)}` : '',
            ordering ? `ordering=${ordering}` : '',
            filterParams,
        ].filter(Boolean).join('&');

        axios
            .get(`${apiUrl}/employees/get-employees/${orgId}/?${query}`, headers)
            .then(function (response) {
                const { employees, total, areas, job_categories, job_titles, management_areas, organization_hqs } = response.data;
                setOrganizationHqs(organization_hqs);
                setManagementAreas(management_areas);
                setAreas(areas);
                setJobCategories(job_categories);
                setJobTitles(job_titles);
                setDataEmployees(employees);
                setFilteredDataEmployees(employees);
                setTableTotal(total);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
                setLoadingText(null);
            });
    }

    // Función para asignar valores del backend a los estados
    useEffect(() => {
        if (dataEmployee) {
            setEmplId(dataEmployee.empl_id || null);
            setEmplUsrId(dataEmployee.empl_usr_id || null);
            setEmplOrgId(dataEmployee.empl_org_id || null);
            setEmplFirstName(dataEmployee.empl_first_name || "");
            setEmplLastName(dataEmployee.empl_last_name || "");
            setEmplDni(dataEmployee.empl_dni || "");
            setEmplGender(dataEmployee.empl_gender || "");
            setEmplEmail(dataEmployee.empl_email || "");
            setEmplAreaId(dataEmployee.empl_area_id || null);
            setEmplAreaName(dataEmployee.empl_area_name || "");
            setEmplJobTitleId(dataEmployee.empl_job_title_id || null);
            setEmplJobTitleName(dataEmployee.empl_job_title_name || "");
            setEmplJobCategoryId(dataEmployee.empl_job_category_id || null);
            setEmplJobCategoryName(dataEmployee.empl_job_category_name || "");
            setEmplManagementAreaId(dataEmployee.empl_management_area_id || null);
            setEmplManagementAreaName(dataEmployee.empl_management_area_name || "");
            setEmplOrganizationHqId(dataEmployee.empl_organization_hq_id || null);
            setEmplOrganizationHqName(dataEmployee.empl_organization_hq_name || "");
            setEmplEntryDate(dataEmployee.empl_entry_date || null);
            setEmplBirthDate(dataEmployee.empl_birth_date || null);
            setEmplActive(dataEmployee.empl_active !== undefined ? dataEmployee.empl_active : true);
        }
    }, [dataEmployee]);

    const onSearch = (value) => {
        const newParams = { ...tableParams, page: 1, search: value };
        setTableParams(newParams);
        getEmployees(orgId, newParams);
    }

    const onTableChange = (pagination, filters, sorter) => {
        let ordering = 'empl_last_name';
        if (sorter && sorter.field) {
            ordering = sorter.order === 'descend' ? `-${sorter.field}` : sorter.field;
        }
        const newParams = {
            ...tableParams,
            page: pagination.current || 1,
            page_size: pagination.pageSize || 20,
            ordering,
            filters: filters || {},
        };
        setTableParams(newParams);
        getEmployees(orgId, newParams);
    }

    const setEmployeesValuesToSee = (empl) => {
        setShowLoading(true);
        setNewEmployee(false);
        setLoadingText("Cargando información del colaborador...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .get(`${apiUrl}/employees/get-employee/${empl.empl_id}/`, headers)
            .then(function (response) {
                const data = response.data.employee
                setNewEmployee(false);
                setModalVisible(true);
                setDataEmployee(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const openNewEmployee = () => {
        setDataEmployee({});
        setNewEmployee(true);
        setModalVisible(true);
    }

    const editEmployee = () => {
        setShowLoading(true);
        setLoadingText("Guardando edición del colaborador...")
        setModalVisible(false);
        
        const formData = new FormData();

        formData.append("empl_id", emplId);
        formData.append("empl_usr_id", emplUsrId);
        formData.append("empl_org_id", emplOrgId);
        formData.append("empl_first_name", emplFirstName);
        formData.append("empl_last_name", emplLastName);
        formData.append("empl_dni", emplDni);
        formData.append("empl_gender", emplGender);
        formData.append("empl_area_id", emplAreaId);
        formData.append("empl_job_category_id", emplJobCategoryId);
        formData.append("empl_job_title_id", emplJobTitleId);
        formData.append("empl_management_area_id", emplManagementAreaId);
        formData.append("empl_organization_hq_id", emplOrganizationHqId);
        formData.append("empl_entry_date", emplEntryDate);
        formData.append("empl_birth_date", emplBirthDate);
        formData.append("empl_active", emplActive);
        formData.append("empl_email", emplEmail);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .put(`${apiUrl}/employees/update-employee/${emplId}/`, formData, headers)
            .then(function (response) {
                setNewEmployee(false);
                showSwal(response.data.message, 2, "Correcto");
                getEmployees(orgId);
                // setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error.data.error, 0, "Error");
                console.error('There was an error!', error);
                setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const createEmployee = () => {
        setShowLoading(true);
        setLoadingText("Guardando colaborador...")
        const formData = new FormData();

        formData.append("empl_org_id", orgId);
        formData.append("empl_first_name", emplFirstName);
        formData.append("empl_last_name", emplLastName);
        formData.append("empl_dni", emplDni);
        formData.append("empl_gender", emplGender);
        formData.append("empl_area_id", emplAreaId);
        formData.append("empl_job_category_id", emplJobCategoryId);
        formData.append("empl_job_title_id", emplJobTitleId);
        formData.append("empl_management_area_id", emplManagementAreaId);
        formData.append("empl_organization_hq_id", emplOrganizationHqId);
        formData.append("empl_entry_date", emplEntryDate);
        formData.append("empl_birth_date", emplBirthDate);
        formData.append("empl_active", emplActive);
        formData.append("empl_email", emplEmail);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .post(`${apiUrl}/employees/create-employee/`, formData, headers)
            .then(function (response) {
                setNewEmployee(false);
                setModalVisible(false);
                showSwal(response.data.message, 2, "Correcto");
                getEmployees(orgId);
                // setShowLoading(false);
            })
            .catch(function (error) {
                // showSwal(error.data.error, 0, "Error");
                console.error('There was an error!', error);
                // setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        setFileCharged(true)
    }

    const resetStates = () => {
        setFileCharged(false)
        setSelectedFile("")
    }

    const uploadFile = async () => {
        setShowLoading(true);
        setIsUploading(true);
        setUploadProgress(0);
        setLoadingText("Iniciando carga...");

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_id", orgId);

        const token = localStorage.getItem('access_token');

        try {
            const response = await fetch(`${apiUrl}/employees/create-update-employees/${orgId}/`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.body) {
                throw new Error('El servidor no soporta respuestas en streaming.');
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop();

                for (const line of lines) {
                    if (!line.trim()) continue;
                    let event;
                    try {
                        event = JSON.parse(line);
                    } catch {
                        continue;
                    }

                    if (event.type === 'progress') {
                        setLoadingText(event.message || 'Procesando...');
                        setUploadProgress(event.percent || 0);
                    } else if (event.type === 'validation_error') {
                        setShowLoading(false);
                        setIsUploading(false);
                        const errorList = (event.detalle_errores || [])
                            .map(e => `Fila ${e.fila}: ${(e.errores || []).join(', ')}`)
                            .join('\n');
                        withReactContent(Swal).fire({
                            title: event.error || 'Errores en el archivo',
                            icon: 'error',
                            html: `<p>Filas con errores: <b>${event.filas_con_errores}</b> de <b>${event.total_filas}</b></p><pre style="text-align:left;max-height:250px;overflow:auto;font-size:12px">${errorList}</pre>`,
                            confirmButtonColor: "#012E40",
                        });
                        return;
                    } else if (event.type === 'server_error') {
                        setShowLoading(false);
                        setIsUploading(false);
                        if (event.missing_columns) {
                            showSwal(`Columnas faltantes: ${event.missing_columns.join(', ')}`, 0, "Error en el archivo");
                        } else {
                            showSwal(event.error || 'Error desconocido', 0, "Error");
                        }
                        return;
                    } else if (event.type === 'done') {
                        setUploadProgress(100);
                        setShowLoading(false);
                        setIsUploading(false);
                        resetStates();
                        getEmployees(orgId);
                        if (event.errores > 0) {
                            const errorList = (event.detalle_errores || [])
                                .map(e => `Fila ${e.fila || e.lote}: ${e.error || (e.errores || []).join(', ')}`)
                                .join('\n');
                            withReactContent(Swal).fire({
                                title: 'Carga parcial',
                                icon: 'warning',
                                html: `<p>Creados: <b>${event.creados}</b> | Actualizados: <b>${event.actualizados}</b> | Errores: <b>${event.errores}</b></p><pre style="text-align:left;max-height:200px;overflow:auto;font-size:12px">${errorList}</pre>`,
                                confirmButtonColor: "#012E40",
                            });
                        } else {
                            showSwal(`Creados: ${event.creados || 0}, Actualizados: ${event.actualizados || 0}`, 2, "Carga exitosa");
                        }
                        return;
                    }
                }
            }

            // Stream cerrado sin evento 'done'
            setShowLoading(false);
            setIsUploading(false);
            showSwal('La carga finalizó sin respuesta esperada del servidor.', 0, "Error");
        } catch (error) {
            setShowLoading(false);
            setIsUploading(false);
            showSwal(`Error de conexión: ${error.message}`, 0, "Error");
            console.error('Error en carga masiva (streaming):', error);
        }
    };

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={isUploading} progress={uploadProgress} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto' }} type="primary" onClick={uploadFile} disabled={!fileCharged}>Cargar colaboradores</Button>
                </div>
            </div>
            <Divider />
            <div className='layout-content'>
                <Button icon={<UserAddOutlined />} onClick={openNewEmployee}>Crear colaborador</Button>
            </div>
            <Divider />
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableEmployees
                    setEmployeesValuesToSee={setEmployeesValuesToSee}
                    data={filteredDataEmployees}
                    total={tableTotal}
                    currentPage={tableParams.page}
                    pageSize={tableParams.page_size}
                    onChange={onTableChange}
                    catalogs={{ organizationHqs, managementAreas, areas, jobCategories, jobTitles }}
                />
            </div>
        </Content>
        <ModalEmployee
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            states={{
                emplId, emplFirstName, emplLastName, emplDni, emplEmail, emplBirthDate, emplGender,
                emplOrganizationHqId, emplOrganizationHqName, emplManagementAreaId, emplManagementAreaName,
                emplAreaId, emplAreaName, emplJobCategoryId, emplJobCategoryName, emplJobTitleId, emplJobTitleName,
                emplEntryDate, emplActive, organizationHqs, managementAreas, areas, jobCategories, jobTitles
            }}
            setters={{
                setEmplId, setEmplFirstName, setEmplLastName, setEmplDni, setEmplEmail, setEmplBirthDate, setEmplGender,
                setEmplOrganizationHqId, setEmplOrganizationHqName, setEmplManagementAreaId, setEmplManagementAreaName,
                setEmplAreaId, setEmplAreaName, setEmplJobCategoryId, setEmplJobCategoryName, setEmplJobTitleId, setEmplJobTitleName,
                setEmplEntryDate, setEmplActive
            }}
            newEmployee={newEmployee}
            editEmployee={editEmployee}
            createEmployee={createEmployee}
        />
    </div>
}

export default OrganizationEmployeesView;